function initialState() {
  return {
    collapsed: false,
    items: []
  };
}

const mutations = {
  updateMenu(state, items) {
    state.items = items;
  },
  collapseMenu(state, collapsed) {
    state.collapsed = collapsed;
  }
};

const actions = {
  setMenu(state, items) {
    state.commit("updateMenu", items);
  },
  toogleMenu(state, collapsed) {
    state.commit("collapseMenu", collapsed);
  }
};

const namespaced = true;

const menu = {
  namespaced,
  state: initialState(),
  actions,
  mutations
};

export default menu;



// WEBPACK FOOTER //
// ./src/store/menu.js